import Service from "../../../Services/index";
const factoryEmployee = {
    namespaced : true,
    state : {
        form : {
            id : '',
            code : '',
            name : '',
            price : '',
            quantity : '',

        },
    },
    mutations : {
        GET_FORM:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA :(state)=>{
            state.form = {
                id : '',
                code : '',
                name : '',
                price : '',
                quantity : '',
            };
        }
    },
    actions : {
        getFactoryEmployee({commit}, {page,data}){
            return Service.factoryEmployee.getFactoryEmployee(page,data);
        },
        showFactoryEmployee({commit},id){
            return Service.factoryEmployee.showFactoryEmployee(id);
        },
        saveFactoryEmployee({commit},{id,data}){
            if(id){
                return Service.factoryEmployee.updateFactoryEmployee(id,data);
            }else{
                return Service.factoryEmployee.createFactoryEmployee(data);
            }
        },
        deleteFactoryEmployee({commit},id){
            return Service.factoryEmployee.deleteFactoryEmployee(id);
        },
        setFormFactoryEmployee({commit},res){
            commit('GET_FORM',res);
        },
        clearFormDataFactoryEmployee({commit}){
            commit('CLEAR_FORM_DATA');
        },
        getFactoryEmployeeAll({commit}){
            return Service.factoryEmployee.getAllFactoryEmployee();
        }
    },
}
export default factoryEmployee
